// Pure client-name helpers shared by useDealClientNames and the call sheet. No React. No Firestore.

// Pulls a display name off a contact/customer record, whatever shape it's in.
// sync_contacts docs vary: app-saved ones carry a computed `name`, but legacy /
// imported ones may only have firstName/lastName (no top-level `name`), and
// inline deal-customer objects use `clientName`. Check them all so no contact
// resolves to blank.
function pickName(record) {
  if (!record) return "";
  const direct = record.name || record.clientName || record.fullName;
  if (direct && direct.trim()) return direct.trim();
  const composed = [record.firstName, record.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return composed;
}

// A deal's `customers` comes in two shapes:
//   - modern: ["contactId", ...]  (looked up in sync_contacts)
//   - legacy: [{ clientName, name?, ... }, ...]
// Resolves one entry to a display name, given a map of fetched contacts.
function nameForEntry(entry, contactsById) {
  if (!entry) return "";
  if (typeof entry === "object") return pickName(entry);
  return pickName(contactsById[entry]);
}

// Joins all of a deal's client names with " & ". Returns "" when none resolve.
export function buildClientName(deal, contactsById) {
  return (deal?.customers || [])
    .map((c) => nameForEntry(c, contactsById))
    .filter(Boolean)
    .join(" & ");
}
